module.exports = __webpack_public_path__ + "img/jianjie.8d4517e1.png";